import {useTranslation} from "react-i18next";
import {Box, Grid} from '@mui/material';
import {observer} from 'mobx-react';
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_MIGR} from './TaxCommon.js';
import {COMM_OK} from '../WsR2.js';
import {TT_SPEC} from '../Util.js';

const MigrDate = (props => {
	const {t} = useTranslation('obs');
	const d = props.date;
	let str = '', jam_str = '';

	if (d.start) {
		str += d.start.dom + '.' + d.start.m;
		str += '-';
		str += d.end.dom + '.' + d.end.m;
	}

	if (d.jam_start) {
		jam_str += d.jam_start.dom + '.' + d.jam_start.m;
		jam_str += '-';
		jam_str += d.jam_end.dom + '.' + d.jam_end.m;
	}

	return (
		<Grid size={{xs: 12}} align={'center'} sx={{mt: 2}}>
			<Box sx={{fontWeight: 'bold'}}>{t('taxons.' + d.type)}</Box>
			{str.length ? <Box>{str}</Box> : null}
			{jam_str.length ? <Box>{t('taxons.most_active') + ' ' + jam_str}</Box> : null}
		</Grid>
	);
});

const TaxMigration = observer(() => {
	const gStorage = useGlobalStorage();
	const migr = gStorage.taxons.migr;
	const {t} = useTranslation('obs');

	function migrRxWs(status, msg) {
		if (status !== COMM_OK || msg.result !== 'OK') {
			console.error('migrRxWs: error ', status, msg);
			return -1;
		}

		if (msg.cmd === 'tax' && msg.op === 'migr') {
// 			console.log('migrRxWs, migr', msg.data);
			gStorage.taxons.setMigration(msg.data.migr);
		} else {
			console.error('migrRxWs: unknown command', msg.cmd, msg.op, msg.result);
		}
	}

	function loadMigr(tax) {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'tax',
			op: 'migr',
			data: {
				taxon: {
					id: tax.id,
				}
			}
		};

// 		console.log('loadDates', msg);
		gStorage.conn.ws.send(msg, migrRxWs);
	};

	if (gStorage.taxons.tab !== TAB_MIGR)
		return null;

	let tax = gStorage.taxons.centerTaxon;
	if (!tax || tax.t_type !== TT_SPEC) 
		return null;

	if (!migr && gStorage.conn.online) {
		loadMigr(tax);
		return null;
	}

	if (!migr)
		return null;

	return (
		<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:300}}>
			{tax.migr_night || tax.migr_day ? 
				<Grid size={{xs: 12}} align={'center'} sx={{mt: 2}}>
					<Box sx={{fontWeight: 'bold'}}>{t('taxons.day') + '/' + t('taxons.night')}</Box>
					<Box>{tax.migr_day + '/' + tax.migr_night + ' %'}</Box>
				</Grid>: 
				null
			}
			{migr.dates.map((d, ind) => {
				return (<MigrDate date={d} key={ind}/>);
			})}
		</Grid>
	);
});

export default TaxMigration;

